import { render, staticRenderFns } from "./SelecaoProcedimentoPrestador.vue?vue&type=template&id=1db01ec3&"
import script from "./SelecaoProcedimentoPrestador.vue?vue&type=script&lang=js&"
export * from "./SelecaoProcedimentoPrestador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports